import React from "react";
import Shape1 from '../Assets/shape1.png'
import Shape2 from '../Assets/shape2.png' 
import Shape3 from '../Assets/shape3.png' 
import "../CSS/SplashScreen.css";

export default function SplashScreen() {
  const letters = "KRISHNA".split("");

  return (
    <>
      <div className="splashScreen">
        <div className="top-logo">
          <img src={Shape1} alt="rays" className="sun-rays" />
          <img src={Shape2} alt="sun" className="sun-body" />
          <img src={Shape3} alt="book" className="sun-bottom" />
        </div>
        <div className="schoolName">
          {letters.map((letter, index) => (
            <span key={index}>{letter}</span>
          ))}
        </div>
        <strong className="tagLine">PUBLIC SCHOOL</strong>
      </div>
    </>
  );
}
